module.exports = __webpack_public_path__ + "static/media/25-10.d32a2831.mp3";